import type {RootState} from "@/lib/store";
import {OrchestratorContext} from "../types";

interface ContextExtras {
    isPwaInstalled: boolean;
    activeFlow: OrchestratorContext["activeFlow"];
}

/**
 * Projects the Redux store + router into the immutable {@link OrchestratorContext}
 * the engine reasons about. This is the *only* coupling point between Redux and
 * the orchestrator — change the store shape, change it here, and the engine is
 * unaffected.
 */
export function buildOrchestratorContext(
    state: RootState,
    route: string,
    extras: ContextExtras,
): OrchestratorContext {
    return {
        route,
        isAuthenticated: !!state.auth.userId,
        userRole: undefined, // wire to your roles slice when available
        isMobile: state.ui.isMobile,
        isPwaInstalled: extras.isPwaInstalled,
        hasPendingDeposit: !!state.ui.isH2H, // proxy signal; refine as needed
        activeFlow: extras.activeFlow ?? null,
        // `activeDialogs` is overridden by the engine with its own truth.
        activeDialogs: [],
        extra: {
            country: state.auth.country,
            isFundsCredited: state.ui.isFundsCredited,
        },
    };
}

/** Detect PWA standalone display mode (client only). */
export function detectPwaInstalled(): boolean {
    if (typeof window === "undefined") return false;
    return (
        window.matchMedia?.("(display-mode: standalone)").matches ||
        // iOS Safari
        (window.navigator as unknown as {standalone?: boolean}).standalone === true
    );
}
